import React from 'react'
import { useTranslation } from 'next-i18next/pages'
import { AggregationOption, Maybe } from '@pylot-data/fwrdschema'
import s from './FilterList.module.scss'
import { Button } from '@corratech/pylot-ui'

type MoreLessLinkProps = {
    isHorizontal?: boolean
    showMoreSize: number
    maxItemsPerList: number
    setMaxItemsPerList: React.Dispatch<React.SetStateAction<number>>
    items: Array<Maybe<AggregationOption>>
}

export const MoreLessLink = ({
    isHorizontal,
    showMoreSize,
    maxItemsPerList,
    setMaxItemsPerList,
    items
}: MoreLessLinkProps): JSX.Element | null => {
    const { t } = useTranslation(['plp'])
    if (isHorizontal || !showMoreSize || showMoreSize >= items.length) {
        return null
    }
    const showMore = items.length > maxItemsPerList
    const label = showMore ? t('See more') : t('See less')
    return (
        <li className={s['filter-more-link']}>
            <Button
                variant="link"
                onClick={(e) => {
                    e.preventDefault()
                    setMaxItemsPerList(showMore ? items.length : showMoreSize)
                }}
            >
                {label}
            </Button>
        </li>
    )
}
